import { OrganizationLogo } from "@saas/organizations/components/OrganizationLogo";
import { cn } from "@ui/lib";

/**
 * The retailer's logo wherever the assistant speaks. Without an uploaded
 * logo the initials sit on the brand colour, not the admin's pastel tile.
 */
export function RetailerMark({
	name,
	logo,
	className,
}: {
	name: string;
	logo: string | null;
	className?: string;
}) {
	return (
		<OrganizationLogo
			name={name}
			logoUrl={logo}
			className={cn(
				"size-8 shrink-0 rounded-[30%] after:rounded-[30%] [&_[data-slot=avatar-fallback]]:rounded-[30%] [&_[data-slot=avatar-fallback]]:bg-(--shop-brand) [&_[data-slot=avatar-fallback]]:text-(--shop-on-brand) [&_img]:rounded-[30%]",
				className,
			)}
		/>
	);
}
